import { render } from "./EventUpdate.vue?vue&type=template&id=e06ba074"
import script from "./EventUpdate.vue?vue&type=script&lang=js"
export * from "./EventUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ahmadsabri-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__